export default "__VITE_ASSET__XL05G9$J__"